import { Component, ElementRef, EventEmitter, Input, OnDestroy, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { PaginationInstance } from 'ngx-pagination';
import { Subscription } from 'rxjs';
import { FacilityExportService } from '../../services/facility-export.service';

@Component({
  selector: 'app-facility-export-activity-log',
  templateUrl: './facility-export-activity-log.component.html',
  styleUrl: './facility-export-activity-log.component.css'
})
export class FacilityExportActivityLogComponent implements OnInit, OnDestroy {
  @Input() hospid: number;
  @Input() facilityExportActivity: any[] = []; // Data from parent
  @Input() isAdmin: boolean = false;
  @Output() showTab: EventEmitter<boolean> = new EventEmitter();

  @ViewChild('pagination') pagin: ElementRef;
  private $subscriptions: Subscription = new Subscription();

  // Pagination
  public searchText = '';
  public maxSize = 7;
  public directionLinks = true;
  public autoHide = false;
  public responsive = false;

  public config: PaginationInstance = {
      id: 'activityPaginationId',
      itemsPerPage: 10,
      currentPage: 1
  };

  public labels: any = {
      previousLabel: 'Previous',
      nextLabel: 'Next',
      screenReaderPaginationLabel: 'Pagination',
      screenReaderPageLabel: 'page',
      screenReaderCurrentLabel: `You're on page`
  };

  constructor(private dataService: FacilityExportService) { }

  ngOnInit() {
    this.showTab.emit(this.isAdmin); 
  }

  // React to input changes - especially isAdmin: This method is added because  When the FacilityExportHistoryComponent loads, it creates the FacilityExportActivityLogComponent with default value (false).
  // The FacilityExportActivityLogComponent.ngOnInit() runs immediately, which emits this.showTab.emit(this.isAdmin) with the default value of isAdmin (false)
  // Later, the parent component's API call completes and sets this.isAdmin = res.isAdmin (true). Hence added ngOnChanges when isAdmin changes.
  ngOnChanges(changes: SimpleChanges) {
    // If isAdmin value changes, emit the updated value
    if (changes.isAdmin) {
      console.log('isAdmin changed to:', this.isAdmin);
      this.showTab.emit(this.isAdmin);
    }
  }
  refreshActivity() {
   this.config.currentPage = 1;
  }

  getActionCss(status) {
    return this.dataService.getActionCss(status);
  }
  getStatusCss(status) {
    return this.dataService.getStatusCss(status);
  }

  // Pagination
  onPageChange(page: number) {
      this.config.currentPage = page;
  }
  onPageBoundsCorrection(page: number) {
      this.config.currentPage = page;
  }

  private Unsubscribe() {
    if (this.$subscriptions) {
      this.$subscriptions.unsubscribe();
    }
  }

  ngOnDestroy(): void {
    this.Unsubscribe();
  }

}
